<div class="bg-dpwhite w-100" style="padding-right:10px">
    <dp-title [title]="title" [icon]="icon"></dp-title>
    <div style="white-space: pre-wrap; font-family: 'Courier New', Courier, monospace;">{{ logContent }}</div>
    @if (logEmptyMessage) {
        <span style="margin-left: 20px;"> {{ (logEmptyMessage | translate)}} </span>
    }
</div>
